import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import logoCabanaWhite from '../images/logonextcabana-white.svg';
import logoCabanaBlack from '../images/logonextcabana-dark.svg';
import { useColorScheme, useMediaQuery } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      © {new Date().getFullYear()} CabanaLink. Todos os direitos reservados.
    </Typography>
  );
}

export default function Footer() {
  const { mode, systemMode } = useColorScheme();
  const mediumSmall = useMediaQuery('(max-width: 914px)');

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 10 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          gap: 8,
          justifyContent: 'space-between',
          // border: '1px solid',
        }}
      >
        <Box
          sx={{
            width: mediumSmall ? '100%' : '35%',
            minWidth: '300px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'left',
          }}
        >
          <img
            src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
            alt="logo-cabanalink"
            style={{ width: '300px', height: 'auto' }}
          />
          <Typography variant="body2" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
            Automação de atendimentos
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
            Seu funcionário virtual, com um atendimento humanizado, fluido e personalizado,
            feito para atender seus clientes 24/7.
            Desenvolvido especialmente para autônomos que querem vender mais com velocidade e eficiência.
          </Typography>
        </Box>
        <Container
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: 'max-content !important',
            gap: { xs: 4, sm: 10, md: 15 },
            p: '0 !important',
            m: '0 !important',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Produto
            </Typography>
            <Link
              component={HashLink}
              color="text.secondary"
              variant="body2"
              to="/#pricing"
              smooth
            >
              Planos
            </Link>
            <Link
              component={HashLink}
              color="text.secondary"
              variant="body2"
              to="/#testimonials"
              smooth
            >
              Depoimentos
            </Link>
            <Link
              component={HashLink}
              color="text.secondary"
              variant="body2"
              to="/#faq"
              smooth
            >
              FAQs
            </Link>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Negócio
            </Typography>
            <Link color="text.secondary" variant="body2" href="/about-us">
              Sobre
            </Link>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Contatos
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', color: 'text.secondary' }}>
              <WhatsAppIcon sx={{ fontSize: 'medium' }} />
              <Link
                color="text.secondary"
                variant="body2"
                href="http://wa.me/5522981007438"
                target="_blank"
              >
                (22) 98100-7438
              </Link>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', color: 'text.secondary' }}>
              <EmailIcon sx={{ fontSize: 'medium' }} />
              <Link
                color="text.secondary"
                variant="body2"
                href="mailto:suporte@cabanalink.com"
              >
                suporte@cabanalink.com
              </Link>
            </Box>
          </Box>
        </Container>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 3, sm: 2 },
          justifyContent: 'space-between',
          pt: { xs: 4, sm: 8 },
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <div>
          <Link color="text.secondary" variant="body2" href="/">
            Início
          </Link>
          <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link color="text.secondary" variant="body2" href="/terms">
            Termos de uso
          </Link>
          <Copyright />
        </div>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          sx={{ justifyContent: 'center', color: 'text.secondary' }}
        >
          <IconButton
            color="inherit"
            size="small"
            href="https://facebook.com/61578770404966"
            target='_blank'
            aria-label="Facebook"
            sx={{ alignSelf: 'center' }}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            href="https://instagram.com/nextalk.ia"
            target='_blank'
            aria-label="Instagram"
            sx={{ alignSelf: 'center' }}
          >
            <InstagramIcon />
          </IconButton> 
          <IconButton
            color="inherit"
            size="small"
            href="http://wa.me/5522981007438"
            target='_blank'
            aria-label="Whatsapp"
            sx={{ alignSelf: 'center' }}
          >
            <WhatsAppIcon />
          </IconButton>
        </Stack>
      </Box>
    </Container>
  );
}